<div class="stepBox flexColumn">
  <ng-container *ngFor="let item of data">
    <div class="stepItem flexRow">
      <div class="avatarBox">
        <img src="{{ item['avatar'] }}" class="staffAvatar" />
        <i nz-icon nzIconfont="xcchenggong1" class="stepStatus stepFinish" *ngIf="item.status == 3"></i>
        <i nz-icon nzIconfont="xcdengdai" class="stepStatus stepWaiting" *ngIf="item.status != 3"></i>
      </div>
      <div class="approvalInfo flexColumn">
        <div class="stepTitleTime flexRow">
          <div class="stepTitle">{{ item.title }}</div>
          <div class="stepTime" *ngIf="item.status == 2">{{ item.time }}</div>
        </div>
        <div class="stepJobName flexRow">
          <div class="stepJob">
            {{ item.job_name }}：{{ item.name }}
            <ng-container *ngIf="item.status == 1">(审批中)</ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="stepLine"></div>
  </ng-container>
</div>
